import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../../shared/shared.module';
import { AddressModule } from '../../address/address.module';
import { AvailabilityModule } from '../availability.module';
import { EditAvailabilityComponent } from './edit-availability.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    AddressModule,
    AvailabilityModule,
  ],
  declarations: [EditAvailabilityComponent],
  exports: [EditAvailabilityComponent],
})
export class EditAvailabilityModule {}
